import { render, staticRenderFns } from "./ReportCellsByProduct.vue?vue&type=template&id=2422d1d5&scoped=true"
import script from "./ReportCellsByProduct.vue?vue&type=script&lang=js"
export * from "./ReportCellsByProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2422d1d5",
  null
  
)

export default component.exports